import React, { useState } from 'react';
import { svgSprite } from '../../../../../hybrid/wrappers';
import { t } from '../../../../../common/components/T';
import IconsModal from '../components/IconsModal/IconsModal';
import css from './FormIcons.module.scss';
import { useWidgetTranslates } from '../../../../../common/utils/utils';

const FormIcons = ({ value, setFormData }) => {
    const transl = useWidgetTranslates('form');

    const [iconsModal, setIconsModal] = useState(false);
    const deleteIcon = () => {
        setFormData('icon', '');
    };
    return (
        <div className={css.formGroupIcon}>
            <p className={css.formIconsLoadLabel} onClick={() => setIconsModal(true)}>
                {svgSprite('painting', {
                    width: '18px',
                    height: '18px',
                    className: css.formIconsLoadLabelIcon
                })}
                {t('iconsButtonSave', 'Выбрать иконку', 'widget', transl, 'form')}
            </p>

            {iconsModal ? (
                <IconsModal
                    value={value}
                    translation={transl}
                    closeHandler={() => setIconsModal(false)}
                    setFormData={setFormData}
                />
            ) : null}

            {value && (
                <div className={css.selectIcon}>
                    <div onClick={deleteIcon} className={css.deleteIcon}>
                        {svgSprite('cross', { className: css.deleteIconSvg })}
                    </div>
                    {svgSprite(
                        value,
                        {
                            width: false,
                            height: '20px',
                            fill: 'var(--darkColor)'
                        },
                        'icons',
                        ['394', '109']
                    )}
                </div>
            )}
        </div>
    );
};
export default FormIcons;
